<template>
	<div style="overflow-x: hidden;background-color: white;position: absolute;left: 0;right: 0;top: 0" class="bg">
		<Navigator :select-index="2"/>
		<SliderBanner :data="slider"/>
		<Info :items="infos"/>
		<Ad :data="ad"/>
		
		<Contact />
		<Footer />
	</div>
</template>

<script>
	import Navigator from '../index/widgets/navigator.vue'
	import Contact from "../index/widgets/Contact.vue"
	import Footer from '../index/widgets/footer.vue'
	
	import SliderBanner from "../local/widgets/SliderBanner.vue"
	import Info from "../local/widgets/Info.vue"
	import Ad from "../local/widgets/Ad.vue"
	export default {
		components: {
			Navigator,
			SliderBanner,
			Contact,
			Footer,
			Ad,
			Info,
		},
		data() {
			return {
				slider: {
					image: require('@/assets/images/card/phone.png'),
					title: '权益卡板块',
					desc: "一网打尽线上线下商城轻松赚佣金，支持淘宝、京东、拼多多、唯品会、苏宁、考拉、美团、饿了么、肯德基、麦当劳、星巴克、充值话费、电费、加油省钱等等上百种组合权益…"
			
				},
				ad: {
					image: require('@/assets/images/local/ad.png'),
					title: '权益卡板块',
					desc: "一网打尽线上线下商城轻松赚佣金，支持淘宝、京东、拼多多、唯品会、苏宁、考拉、美团、饿了么、肯德基、麦当劳、星巴克、充值话费、电费、加油省钱等等上百种组合权益…"
				},
				infos: [{
						title: '热门推荐',
						desc: '使用智莺系统购买套餐、饮品、视频会员的商品更惠，不仅轻松解决高峰排队,顾客手机即可下单,订单不出错,无需客服协助,有效节约了人力成本!',
						imgUrl: require("@/assets/images/card/1.png"),
					},
					{
						title: '餐饮美食',
						desc: '使用智莺系统购买肯德基、必胜客、星巴克、COCO、哈根达斯、太平洋咖啡、奈雪的茶的商品更优惠，不需要购买饿了么会员，就能天天领红包，超值优惠天天领，下单还能领返佣实实在在省钱',
						imgUrl: require("@/assets/images/card/2.png"),
					},
					{
						title: '优惠充值',
						desc: '使用智莺系统购买百度网盘、QQ会员、迅雷会员、微博会员、DQ冰淇淋、喜茶、Keep会员的商品更优惠，轻松购物无需客服协助,有效节约了人力成本!',
						imgUrl: require("@/assets/images/card/3.png"),
					},
					
					{
						title: '影音娱乐',
						desc: '在智莺app充值网易云、QQ音乐、酷狗音乐、腾讯视频、爱奇艺、芒果TV等会员拿返利，下单领返佣实实在在省钱，网上购物返利首选平台!比价格功能，让您轻松选择最优惠的商城,让您购物更优惠!',
						imgUrl: require("@/assets/images/card/4.png"),
					},
					{
						title: '生活服务',
						desc: '使用智莺系统购买美团外卖、饿了么、京东PLUS、滴滴快车、美团单车、飞猪会员、青桔单车、知乎盐选的商品更优惠，下单领返佣实实在在省钱，网上购物返利首选平台!比价格功能，让您轻松选择最优惠的商城,让您购物更优惠!',
						imgUrl: require("@/assets/images/card/5.png"),
					},
				]
			}
		}
	}
</script>

<style scoped lang="scss">
	@media (max-width: 767px) {
		.bg {
			background-size: auto 500px;
			background-repeat: no-repeat;		
		}
	}
	
	@media (min-width: 767px) {
		.bg {
			background-size: 100% auto;
			background-repeat: no-repeat;		
		}
	}
	
	@media (min-width: 992px) {
		.bg {
			background-size: 100% auto;
			background-repeat: no-repeat;		
		}
	}
	
	.bg {
		background-image: url(../../assets/images/local/bg.png);
		// background-size: 100% 500px;
		
	}
</style>